// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604281103/js/" + chunkId + "." + {"44":"0d185000","225":"8991243d","481":"1473a88c","486":"1d5dc85c","770":"b15fe6a1"}[chunkId] + ".0.9007795655392643.chunk.js";
};